import ClienteEnderecoEntregaModel from "../models/clienteEnderecoEntregaModel";

import { IService } from "./base/iService";

export default class ClienteEnderecoEntregaService extends IService<ClienteEnderecoEntregaModel> {
    constructor() {
        super("ClienteEnderecoEntrega");
    }
}